export default __webpack_public_path__ + "static/media/image-not-available.9ddffd4a.png";